module.exports = "/images/marker-black.svg?05f55dad54f529545ad479841f8c89c2";